<template>
  <el-dialog :title="title" :visible.sync="domVisible" :lock-scroll="false" width="680px" top="10vh" :before-close="handleClose" v-loading="loading">
    <div>
      <div class="dialogData">
        <el-form :model="passForm" ref="passForm" :rules="rules" :hide-required-asterisk='true' class="set_form">
          <div class="address_box">
            <el-form-item :label="$t('kyc.FirstName')" class="info_box" prop="firstName">
              <el-input class="info_ipt" v-model="passForm.firstName" maxlength="30"  @input="forbidInput('firstName')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kyc.LastName')" class="info_box" prop="lastName">
              <el-input class="info_ipt" v-model="passForm.lastName" maxlength="30" @input="forbidInput('lastName')"></el-input>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('kyc.DateOfBirth')" class="info_box" prop="dateOfBirth">
              <el-date-picker class="info_ipt" type="date" placeholder="MM / DD / YYYY" format="MM / dd / yyyy" value-format="yyyy-MM-dd" v-model="passForm.dateOfBirth"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('base.phoneNumber')" class="info_box" prop="phoneNumber">
              <el-input class="info_ipt" v-model="passForm.phoneNumber" maxlength="30"  @input="forbidInput('phoneNumber','num')">
                <template slot="prepend">+1</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('kyc.lastNumber')" class="info_box" prop="socialSecurityNumber">
              <el-input class="info_ipt" v-model="passForm.socialSecurityNumber" placeholder="***-**- 8888" maxlength="4"  @input="forbidInput('socialSecurityNumber','num')"></el-input>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('kyc.street')" class="info_box" prop="line1">
              <el-input class="info_ipt" v-model="passForm.line1" maxlength="90" @input="forbidInput('line1')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kyc.PostalCode')" class="info_box" prop="postalCode">
              <el-input class="info_ipt" v-model="passForm.postalCode" maxlength="30" @input="forbidInput('postalCode')"></el-input>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('kyc.City')" class="info_box" prop="city">
              <el-input class="info_ipt" v-model="passForm.city" maxlength="30" @input="forbidInput('city')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base.state')" class="info_box" prop="subdivision">
              <el-select v-model="passForm.subdivision" filterable class="info_ipt" :placeholder="$t('base.selectState')">
                <el-option :label="item.EName" :value="item.Code" v-for="(item,index) in getAreas" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="set_btn">
            <el-button type="primary" :disabled="disabled" @click="submitForm('passForm')">{{$t('base.confirm')}}</el-button>
          </div>
        </el-form>
        <!-- <div class="powerJumio">powered by jumio</div> -->
      </div>
    </div>
    </div>
  </el-dialog>
</template>
<script>
import {isEmoji,getUser,getInfo } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  data() {
    return {
      userInfo:null,
      loading: false,
      getAreas: '',
      disabled: false,
      passForm: {
        firstName: '',
        lastName: '',
        phoneNumber: "",
        socialSecurityNumber: '',
        dateOfBirth: '',
        line1: '',
        postalCode: '',
        city: '',
        subdivision: '',
        
      },
      rules: {
        firstName: [
          { required: true, message: 'Please enter your First Name', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Please enter your Last Name', trigger: 'blur' },
        ],
        dateOfBirth: [
          { required: true, message: 'Please enter your Date of Birth', trigger: 'blur' },
        ],
        phoneNumber: [
          { required: true, message: this.$t('rules.enterPhone'), trigger: 'blur' }
        ],
        socialSecurityNumber: [
          { required: true, message: 'Please enter your Security Number', trigger: 'blur' },
        ],
        line1: [
          { required: true, message: this.$t('rules.enterAddress'), trigger: 'blur' },
        ],
        postalCode: [
          { required: true, message: 'Please enter your Postal Code', trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('rules.enterCity'), trigger: 'blur' }
        ],
        subdivision: [
          { required: true, message: this.$t('rules.selectState'), trigger: 'change' }
        ],
      }
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    type: Number
  },
  watch: {},
  filters: {},
  created() {
    this.getAreasList()
    this.userInfo=getInfo()
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'verifynow', false)
    },
    //获取地区列表
    getAreasList(val) {
      let that = this;
      let data = { code: 'US' }
      that.$get(that.$interface.GetAreas, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;

        }
      })
    },
    forbidInput(e,type) {
      let that=this
      that.passForm[e]=isEmoji(that.passForm[e], 0)
      if(type=='num'){
        that.passForm[e]=that.passForm[e].replace(/^\D*$/g,'')
      }
      
    },
    submitForm(formName) {
      let that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled=true
          let data = {
            id:that.userInfo.MappingUserId,
            firstName: that.passForm.firstName,
            lastName: that.passForm.lastName,
            phoneNumber: '+1'+that.passForm.phoneNumber,
            socialSecurityNumber: that.passForm.socialSecurityNumber,
            dateOfBirth: that.passForm.dateOfBirth,
            address: {
              line1: that.passForm.line1,
              postalCode: that.passForm.postalCode,
              city: that.passForm.city,
              subdivision: that.passForm.subdivision,
              country: 'USA'
            }
          }
          that.$post(that.$interface.CreateSSNForUS, data).then(res => {
            if(res.Result){
              getUser(that.userInfo,0)
              that.handleClose()
              setTimeout(function(){
                window.location.reload();
              },1500)
            }else{
              that.disabled=false
              that.$message({
                  type: 'error',
                  duration: 1000,
                  message: res.Msg
                });
            }
          })
        }
      })
    }
  },
  beforeDestroy() {
    this.handleClose()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";



.dialogData .address_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.info_box {
  width: 47%;
}

.info_box+.info_box {
  margin-left: 24px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.set_btn {
  text-align: center;
  margin-top: 20px;
}

.set_btn .el-button {
  width: 50%;
}

.powerJumio {
  display: flex;
  justify-content: center;
  color: #a0a0a0;
  margin: 50px 0 10px;
}

.powerJumio:before {
  content: '';
  height: auto;
  width: 45px;
  background: url(/static/images/icon/icon_logo_jumio.png) no-repeat;
  background-size: contain;
  margin-right: 8px;
}
/deep/ .info_ipt .el-input-group__prepend{
  padding: 0 10px;
  border: 1px solid #c8c8c8;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/jumioVerificationUS.vue